import { render, staticRenderFns } from "./vendor-psent.vue?vue&type=template&id=6e2d380e"
import script from "./vendor-psent.vue?vue&type=script&lang=js"
export * from "./vendor-psent.vue?vue&type=script&lang=js"
import style0 from "./vendor-psent.vue?vue&type=style&index=0&id=6e2d380e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports